/**
 * Loads carrier and location data for related phone numbers.
 *
 * Numbers and View Report links are server-rendered and visible by default.
 * Per-card skeletons briefly show while carrier/location labels hydrate.
 * If enrichment fails or has nothing useful, the skeleton is removed and
 * the card collapses to number + View Report only (no empty gap, no animation).
 */
export function loadRelatedPhonesData() {
  const phoneCards = document.querySelectorAll(
    "#relatedPhonesContainer .related-phone-card",
  );

  if (phoneCards.length === 0) {
    return;
  }

  phoneCards.forEach((card) => {
    const phoneNumber = card.getAttribute("data-phone");
    const cardBody = card.querySelector(".card-body");
    const viewReportLink = cardBody.querySelector("a.strong");
    const skeleton = card.querySelector(".related-phone-skeleton");

    if (skeleton) {
      skeleton.classList.remove("hidden-content");
    }

    const removeSkeleton = () => {
      if (skeleton && skeleton.parentNode) {
        skeleton.remove();
      }
    };

    fetch(`/phone/api/carrier-location/${phoneNumber}/`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const carrierValue = data.carrier || "Unknown";
        const location = data.location || "";
        const state = data.state || "";
        const fullLocation =
          location && state
            ? `${location}, ${state}`
            : location || state || "N/A";

        removeSkeleton();

        if (carrierValue !== "Unknown") {
          const carrierParagraph = document.createElement("p");
          carrierParagraph.className = "carrier-info";

          const carrierLabel = document.createElement("span");
          carrierLabel.className = "label";
          carrierLabel.textContent = "Carrier |";

          const carrierValueSpan = document.createElement("span");
          carrierValueSpan.className = "carrier-value";
          carrierValueSpan.textContent = " " + carrierValue;

          carrierParagraph.appendChild(carrierLabel);
          carrierParagraph.appendChild(carrierValueSpan);

          cardBody.insertBefore(carrierParagraph, viewReportLink);
        }

        if (fullLocation !== "N/A") {
          const locationParagraph = document.createElement("p");
          locationParagraph.className = "location-info";
          locationParagraph.textContent = fullLocation;

          cardBody.insertBefore(locationParagraph, viewReportLink);
        }
      })
      .catch(() => {
        removeSkeleton();
      });
  });
}
